import { render, staticRenderFns } from "./OrderReminderAction.vue?vue&type=template&id=237f1ab4"
import script from "./OrderReminderAction.vue?vue&type=script&lang=js"
export * from "./OrderReminderAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports